export default __webpack_public_path__ + "static/1-c9d23df558d4c9d4260bdaf38e70f390.gif";